var _a;
import { ErrorType } from "../types/ErrorType";
var PRODUCT_CREATE_ERROR_MESSAGE_IDS = (_a = {},
    _a[ErrorType.ONE_OFF_PUBLISHER_CANNOT_CREATE_PRODUCT] = "ui-br-agency.product.error.oneOffPublisherCannotCreate",
    _a);
var GENERIC_PRODUCT_CREATE_ERROR_ID = "ui-br-agency.product.error.submit";
/** Maps a backend error code of a failed product create to a translation id. */
export var resolveProductCreateErrorMessageId = function (code) {
    var _a;
    return (_a = (code && PRODUCT_CREATE_ERROR_MESSAGE_IDS[code])) !== null && _a !== void 0 ? _a : GENERIC_PRODUCT_CREATE_ERROR_ID;
};
